// // hooks/useFetchLoginUser.js
// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { setUserDetails } from "../store/userSlice";
// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";
// import { jwtDecode } from "jwt-decode";

// const useFetchLoginUser = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Check if token exists for protected routes
//     const publicPaths = ["/", "/login", "/sign-up", "/un-authorized", "/register", "/forgot-password", "/reset-password", "/not-found"];
//     const currentPath = window.location.pathname;

//     // Check if current path starts with any public path
//     const isPublic = publicPaths.some(
//       (path) =>
//         currentPath === path ||
//         (path === "/reset-password" && currentPath.startsWith("/reset-password"))
//     );

//     const token = localStorage.getItem("ata"); //apd token access

//     if (isPublic) {
//       setLoading(false);
//       return;
//     }
    
//     if (!token && !isPublic) {
//       setLoading(false);
//       navigate("/un-authorized");
//       return;
//     }
    
//     // let userId = "";
//     // if (token) {
//     //   const decoded = jwtDecode(token);
//     //   userId = decoded?.id;

//     // }

//     if (token) {
//       try {
//         const decoded = jwtDecode(token);        

//         // check expiry
//         const currentTime = Date.now() / 1000;
//         if (decoded.exp && decoded.exp < currentTime) {
//           // Token expired
//           navigate("/un-authorized");
//         } 
//         // else {
//         //   userId = decoded?.userId || decoded?.id;
//         // }
//       } catch (error) {
//         // Invalid token structure
//         navigate("/un-authorized");
//       }
//     }
    
//     const fetchUser = async () => {
//       try {
//         const res = await api.get(SummaryApi.getMe.url);
//         dispatch(setUserDetails(res.data.data));
//       } catch (err) {
//         console.error("Failed to fetch user", err);
//         if (err.response?.status === 401) {
//           localStorage.removeItem("token");
//           navigate("/un-authorized");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUser();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [dispatch, navigate]);

//   return loading;
// };

// export default useFetchLoginUser;

// hooks/useFetchLoginUser.js

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { setUserDetails } from "../store/userSlice";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import { isPublicPath } from "../common/publicRoutes";

const useFetchLoginUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const isPublic = isPublicPath(currentPath);
    const token = localStorage.getItem("ata");

    // Public routes (Login, Sign-up, Careers, Reset Password, etc.)
    if (isPublic) {
      setLoading(false);
      return;
    }

    // Protected routes without token
    if (!token) {
      setLoading(false);
      navigate("/un-authorized");
      return;
    }

    // Validate JWT token
    try {
      const decoded = jwtDecode(token);

      const currentTime = Date.now() / 1000;

      // Token expired
      if (decoded?.exp && decoded.exp < currentTime) {
        localStorage.removeItem("ata");
        setLoading(false);
        navigate("/un-authorized");
        return;
      }
    } catch (error) {
      // Invalid token
      localStorage.removeItem("ata");
      setLoading(false);
      navigate("/un-authorized");
      return;
    }

    // Fetch logged-in user details
    const fetchUser = async () => {
      try {
        const res = await api.get(SummaryApi.getMe.url);

        dispatch(setUserDetails(res.data.data));
      } catch (err) {
        console.error("Failed to fetch user", err);

        if (err?.response?.status === 401) {
          localStorage.removeItem("ata");
          navigate("/un-authorized");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, navigate]);

  return loading;
};

export default useFetchLoginUser;